import React, { useRef, useState } from "react";

import HotspotIcon from "./icon/HotspotIcon";
import ProductHotspotExplainer from "./explainer/ProductHotspotExplainer";
import ProductHotspotInfoBox from "./ProductHotspotInfoBox";
import calculateImagePosition from "../../../utils/calculateImagePosition";
import hotspotClasses from "./HotspotStyles.module.css";

export default ({ hotspots, imageSrc }) => {
  const imageRef = useRef();
  const [selected, setSelected] = useState();
  const toggleSelected = (id) => {
    if (selected === id) {
      setSelected(null);
    } else {
      setSelected(id);
    }
  };
  const selectedIcon = hotspots[selected];
  const imageWidth = imageRef.current && imageRef.current.naturalWidth;
  const imageHeight = imageRef.current && imageRef.current.naturalHeight;

  const { imageX, imageY } = selectedIcon
    ? calculateImagePosition({ hotspot: selectedIcon })
    : {};
  return (
    <div className={hotspotClasses.infoContainer}>
      <div>
        <div className={hotspotClasses.infoBox}>
          {selectedIcon ? (
            <ProductHotspotInfoBox
              imageSrc={imageSrc}
              imageX={imageX}
              imageY={imageY}
              selectedIcon={selectedIcon}
            />
          ) : (
            <ProductHotspotExplainer imageSrc={imageSrc} />
          )}
        </div>
      </div>
      <div
        className="position-relative"
        style={{ minWidth: imageWidth, minHeight: imageHeight }}
      >
        <img alt="feature hotspot" ref={imageRef} src={imageSrc} />
        {Object.keys(hotspots).map((key) => {
          const { left, top } = hotspots[key];
          const isSelected = selected === key;
          return (
            <HotspotIcon
              key={key}
              id={key}
              left={left}
              top={top}
              isSelected={isSelected}
              onClick={(e) => {
                e.stopPropagation();
                toggleSelected(key);
              }}
            />
          );
        })}
      </div>
    </div>
  );
};
